/**
 * Reports API base URL (no trailing slash).
 * Production: same-origin /api/reports (nginx proxies to ztask-reports).
 * Local dev: set REACT_APP_REPORTS_API_URL=http://localhost:3000 in .env.
 */
export const getReportsApiBaseUrl = () => {
  const envUrl = (process.env.REACT_APP_REPORTS_API_URL || '').trim();
  if (envUrl) {
    return envUrl.replace(/\/$/, '');
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return 'http://localhost:3000';
};
